export default function () {
    const config = useRuntimeConfig();

    return {
        appStage: config.public.appStage,
        apiUrl: config.public.apiUrl,
        pusher: config.public.pusher,
    }
}